import { SET_MESSAGE_COUNT } from './types';

// Takes the count directly. The previous signature took the count wrapped in an object and the
// reducer read `payload.messageCount.messageCount` back out of it, so every caller had to know to
// build a matching shape.
export const setMessageCount = messageCount => ({
    type: SET_MESSAGE_COUNT,
    payload: { messageCount: messageCount }
});
